import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {ApplicationService} from '../../services/application.service';
import {environment} from '../../../environments/environment';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {DataService} from '../../services/data.service';

@Component({
  selector: 'app-receipt-file-replace-upload',
  templateUrl: './receipt-file-replace-upload.component.html',
})
export class ReceiptFileReplaceUploadComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  selectedFiles: ExcFileItem[] = [];
  acceptedFileTypes = ['PDF', 'DOCX', 'XLSX', 'JPEG', 'PNG'];

  files = {
    selection: [],
  };

  private _MAXFILESIZE = environment.rest.MAXFILESIZE;
  get MAXFILESIZE(): number {
    return this._MAXFILESIZE;
  }

  Events = new ExgApplicationEventEmitter();
  TaskSummary: ITaskSummaryData | any = this.dataSvc.Task.Summary.Get();

  showUpload = true;
  showDocuments = false;

  receipt = {
    vorgID: undefined,
    rcpt_fileStreamID: undefined,
  };

  localConfig = {
    openAttachmentInBrowser: (doc: any): void => {
      if (doc.dokMIME.includes('/pdf') || doc.dokMIME.includes('image/')) {
        this.appSvc.file.dokument.openInBrowser(doc.dokID);
      }
      else {
        this.modalService.showToast(this.getRessource('OpenInBrowser.NotOpenInBrowser'), 'md-toast', 'fas fa-exclamation');
      }
    },
    addAttachmentToUpload: (doc: any): void => {
      if (this.isValidPDFExtension(doc.dokExtension)) {
        this.excRest.get(
            this.excRest.computeUrl('DocumentR', {dokID: doc.dokID}), {})
          .subscribe((rtVal: any) => {
            const docFile = this.base64ToFile(
              rtVal.data.IMG,
              doc.dokName,
              doc.dokMIME
            );

            this.selectedFiles.push(
              ExcFileItem.fromFile(docFile)
            );
          });
      }
    }
  };
  AttachmentTableData = [] as any[];
  ConfigAttachmentTable: any;

  constructor(
    public modalService: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    public excRest: ExcRestService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ConfigAttachmentTable = {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.attachmentJagTable.data || this.TaskSummary?.attachmentJagTable?.isEmpty) {
          this.ConfigAttachmentTable.state = 2;
        } else {
          this.ConfigAttachmentTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    };

    this.registerEvents();

    if (this.data) {
      this.receipt = JSON.parse(JSON.stringify(this.data));

      this.TaskSummary = this.dataSvc.Task.Summary.Get(this.receipt.vorgID, undefined, {Events: this.Events});
    }
  }

  registerEvents(): void {
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.ConfigAttachmentTable.ready();
        if (this.TaskSummary?.attachmentJagTable?.data) {
          this.AttachmentTableData = this.TaskSummary?.attachmentJagTable?.jagdata;

          for (const folder of this.AttachmentTableData) {
            for (const doc of folder.documents) {
              doc.dokExtension = doc.dokName.slice(doc.dokName.lastIndexOf('.') + 1);
            }
          }
        }
      }
    });
  }

  upload(): void {
    if (this.getFiles().length > 0) {
      this.modalService.action({
        formData: ExcFileItem.getFormData(this.getFiles(), {})
      });
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalService.close();
  }

  onFilesSelect(files: ExcFileItem): void {
    this.selectedFiles = this.selectedFiles.concat(files);
  }

  delete(index: any): void {
    this.selectedFiles = this.selectedFiles.filter(file => file !== index);
  }

  isValidPDF(fileSize: number, fileExtension: string): boolean {
    return this.proofFileSize(fileSize) && this.isValidPDFExtension(fileExtension);
  }

  isValidPDFExtension(fileExtension: string): boolean {
    if (fileExtension) {
      return this.acceptedFileTypes.includes(fileExtension.toUpperCase());
    }
    return false;
  }

  proofFileSize(size: number): boolean {
    return size < this.MAXFILESIZE;
  }

  getFiles(): any {
    const files = this.selectedFiles.filter((file: any) => this.isValidPDF(file.size, file.extension));
    if (!files) {
      return [];
    }
    return files;
  }

  move(index: number, dir: -1 | 1): void {
    const target = index + dir;
    if (target < 0 || target >= this.selectedFiles.length) {
      return;
    }
    const copy = [...this.selectedFiles];
    [copy[index], copy[target]] = [copy[target], copy[index]];
    this.selectedFiles = copy;
  }

  onFileDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.selectedFiles, event.previousIndex, event.currentIndex);
      this.selectedFiles = [...this.selectedFiles];
    }
  }

  base64ToFile(
    base64: string,
    fileName: string,
    mimeType: string
  ): File {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new File(
      [bytes],
      fileName,
      { type: mimeType }
    );
  }
}
